import "@rmlibrary/video-controls";
import "@rmlibrary/fetch";
import "./accordion";
import "./common";

import {
    buildTranscriptHTML,
    filterObjectByKeys,
    getLanguage,
    getTextWidth,
    getValueFromInput,
    hidePopup,
    sanitiseDescriptions,
    showPopup,
} from "./utilities";
import { generatePDF, setupPreview } from "./pdf";
import { getLineGraphAxesLimits, getLineGraphCSS, getLineGraphDataset, getLineGraphOptions } from "./graphing";

import $ from "jquery";
import Formatter from "@rmlibrary/formatting";
import { RMNumberInput } from "@rmlibrary/inputs";
import { calculateResults } from "./calculations";
import { drawGraph } from "@rmlibrary/graph";
import { storePrintValues } from "./storage";

const lang = getLanguage();
const formatter = new Formatter(lang);
const videoControls = $("#controls").get(0);
const sequenceGraphContainer = $(".graph-container");
const sequenceGraph = $("#sequence-graph");
const sequenceGraphPrint = $("<canvas/>");
const rateOfReturnsTableContainer = $(".rate-table-container");
const printReportButton = $("#print-btn");
const pdfReportButton = $("#pdf-btn");
const updateButton = $("#update-button");
const returnTable = $("#return-table");

let isUpdateClicked = false;
let clientWidth = document.documentElement.clientWidth;

function setupButtons() {
    printReportButton.on("click", (event) => {
        if (!validation() || !isUpdateClicked) {
            event.preventDefault();
        } else {
            window.open("print.html")
        }
    });

    pdfReportButton.on("click", (event) => {
        if (validation() && isUpdateClicked) {
            updatePdfValues();
            generatePDF();
        } else {
            event.preventDefault();
        }
    });

    updateButton.prop("disabled", true);
    printReportButton.prop("disabled", true);
    pdfReportButton.prop("disabled", true);

    updateButton.on("click", function () {
        updateButton.prop("disabled", true);
        if (validation()) {
            printReportButton.removeAttr("disabled");
            pdfReportButton.removeAttr("disabled");

            const inputValues = getInputValues();
            const results = calculateResults({ ...inputValues });
            const { stateOfMarket } = inputValues;

            sequenceGraphContainer.find(".legend-item[data-value]").hide();
            rateOfReturnsTableContainer.find(".rate-table-desktop [data-value]").hide();
            rateOfReturnsTableContainer.find(".rate-table-mobile [data-value]").hide();
            ["goodStart", "stableReturn", "badStart"].forEach((state) => {
                returnTable.find(`[data-value='${state}']`).hide();
            });
            stateOfMarket.forEach((state) => {
                sequenceGraphContainer.find(`.legend-item[data-value='${state}']`).show();
                rateOfReturnsTableContainer.find(`.rate-table-desktop [data-value='${state}']`).show();
                rateOfReturnsTableContainer.find(`.rate-table-mobile [data-value='${state}']`).show();
                updateSRReturnsValues(state, results);
            });
            $(".sequence-img").hide();
            sequenceGraphContainer.show();
            drawLineGraph(results);
            rateOfReturnsTableContainer.show();
            updatePrintValues(results);
            isUpdateClicked = true;
            printReportButton.css("opacity", "1");
            pdfReportButton.css("opacity", "1");
        } else {
            printReportButton.prop("disabled", true);
            pdfReportButton.prop("disabled", true);
            sequenceGraphContainer.find(".legend-item[data-value]").show();
            rateOfReturnsTableContainer.find(".rate-table-desktop [data-value]").show();
            rateOfReturnsTableContainer.find(".rate-table-mobile [data-value]").show();
            sequenceGraphContainer.hide();
            rateOfReturnsTableContainer.hide();
            $(".sequence-img").show();
        }
    });

    $("#watch-video, .play-btn-small").on("click", () => {
        $(".cp-controls").css("display", "flex");
        $("#watch-video").attr("disabled", "true");
        $("#video-thumbnail, .play-btn-small").hide();
        $("video").get(0).play();
    });
}

function setupVideo() {
    $(".rm-slider-handle").attr("aria-label", "video progress bar");
    videoControls.toggleIndicators(true);
    fetch("./vtt/sequence.json")
        .then((res) => res.json())
        .then((res) => {
            if (res.captions) videoControls.addTextTrack("captions", res.captions);
            if (res.descriptions) {
                videoControls.addTextTrack("descriptions", res.descriptions);
                const controls = $("rm-video-controls")[0];
                let descriptionsArr = controls.descriptions;
                descriptionsArr = sanitiseDescriptions(descriptionsArr);

                controls.updateTranscript(buildTranscriptHTML(descriptionsArr), "#transcript-body", "transcript.html");
            }
        });
    $("video").on("seeking", () => $("#watch-video").attr("disabled", "true"));
    $("video").on("ended", () => $("#watch-video").removeAttr("disabled"));
}

function getInputValues() {
    const stateOfMarket = $("#state-of-market-checkboxes input:checked")
        .map(function () {
            return $(this).val();
        })
        .get();
    const totalRetirementSavings = formatter.parseNumber(getValueFromInput("#retirement-savings"));
    const withdrawalAmount = formatter.parseNumber(getValueFromInput("#withdrawal-amount"));
    const withdrawalFrequency = formatter.parseNumber(getValueFromInput("#withdrawal-frequency"));

    return {
        stateOfMarket,
        totalRetirementSavings,
        withdrawalAmount,
        withdrawalFrequency,
    };
}

function updatePrintValues(results) {
    const { stateOfMarket, totalRetirementSavings, withdrawalAmount, withdrawalFrequency } = getInputValues();
    const filteredResults = filterObjectByKeys(results, stateOfMarket, false);
    const withdrawalFrequencyText = $(`#withdrawal-frequency option[value=${withdrawalFrequency}]`).text();
    const stateOfMarketTexts = stateOfMarket.map((value) =>
        $(`#state-of-market-checkboxes label[data-value=${value}]`).text(),
    );

    storePrintValues({
        ...filteredResults,
        graphSrc: sequenceGraphPrint.get(0).toDataURL(),
        stateOfMarket: stateOfMarketTexts,
        totalRetirementSavings,
        withdrawalAmount,
        withdrawalFrequency: withdrawalFrequencyText,
    });
}

function updatePdfValues() {
    const { stateOfMarket, totalRetirementSavings, withdrawalAmount, withdrawalFrequency } = getInputValues();
    const graphSrc = sequenceGraphPrint.get(0).toDataURL();
    const format = lang === "en" ? "mmmm ddd, yyyy" : "ddd mmmm yyyy";
    const date = formatter.formatDate(new Date(), format);
    const withdrawalFrequencyText = $(`#withdrawal-frequency option[value=${withdrawalFrequency}]`).text();
    $("#pdf-returns-graph-src").attr("src", graphSrc);
    $("#pdf-returns-date").text(date);
    $("#pdf-returns-total-retirement-savings").text(formatter.formatCurrency(totalRetirementSavings));
    $("#pdf-returns-withdrawal-amount").text(formatter.formatCurrency(withdrawalAmount));
    $("#pdf-returns-withdrawal-frequency").text(withdrawalFrequencyText);

    if (stateOfMarket.indexOf("badStart") > -1) {
        $("#pdf-returns-bad-start").show();
    } else {
        $("#pdf-returns-bad-start").hide();
    }

    if (stateOfMarket.indexOf("goodStart") > -1) {
        $("#pdf-returns-good-start").show();
    } else {
        $("#pdf-returns-good-start").hide();
    }

    if (stateOfMarket.indexOf("stableReturn") > -1) {
        $("#pdf-returns-stable-return").show();
    } else {
        $("#pdf-returns-stable-return").hide();
    }
}

function setUpGraphResizing() {
    $(window).on("resize", () => {
        if (document.documentElement.clientWidth === clientWidth) {
            return false;
        }

        clientWidth = document.documentElement.clientWidth;

        if (sequenceGraphContainer.is(":visible") && validation()) {
            const inputValues = getInputValues();
            const results = calculateResults({ ...inputValues });

            drawLineGraph(results);
        }
    });
}

function drawLineGraph(results) {
    function drawCallback({ lastYear, name, portfolioValue, screenPixelRatio, screenWidth, year }) {
        return (context, x, y) => {
            if (lastYear) {
                context.save();

                const { stateOfMarket } = getInputValues();
                const filteredResults = filterObjectByKeys(results, stateOfMarket, false);
                const allDataPointKeys = ["badStart", "stableReturn", "goodStart"];
                const names = {
                    "Bad Start": "badStart",
                    "Good Start": "goodStart",
                    "Stable Return": "stableReturn",
                };
                let dataPointKeys = [];

                allDataPointKeys.forEach((dataPointKey) => {
                    if (dataPointKey in filteredResults) {
                        dataPointKeys = dataPointKeys.concat(dataPointKey);
                    }
                });

                name = names[name];

                if (dataPointKeys.length > 1) {
                    let lastDataPointsKey = "";
                    if ("badStart" in filteredResults) {
                        lastDataPointsKey = "badStart";
                    } else if ("stableReturn" in filteredResults) {
                        lastDataPointsKey = "stableReturn";
                    } else {
                        lastDataPointsKey = "goodStart";
                    }
                    if (dataPointKeys.length > 2) {
                        lastDataPointsKey = "stableReturn";
                    }

                    const { portfolioValue: lastPortfolioValue } = filteredResults[lastDataPointsKey][year];
                    const {
                        yAxis: { max },
                    } = getLineGraphAxesLimits(results);
                    const lastPortfolioValueYCoords = (lastPortfolioValue / max) * 530;

                    const currentPortfolioValueYCoords = (portfolioValue / max) * 530;
                    const currentPortfolioValueIndex = dataPointKeys.indexOf(name);

                    let yOffset = 20;
                    if (screenWidth === "small") {
                        yOffset = 30;
                    }

                    if (dataPointKeys.length < 3) {
                        if (Math.abs(currentPortfolioValueYCoords - lastPortfolioValueYCoords) < 15) {
                            y = y - currentPortfolioValueIndex * yOffset;
                        }
                    } else {
                        if (Math.abs(currentPortfolioValueYCoords - lastPortfolioValueYCoords) < 15) {
                            if (name === "goodStart") {
                                y = y - yOffset * screenPixelRatio;
                            } else if (name === "badStart") {
                                y = y + yOffset * screenPixelRatio;
                            }
                        }
                    }
                }

                const colors = {
                    badStart: $(".circle-green").css("background-color"),
                    goodStart: $(".circle-turquoise").css("background-color"),
                    stableReturn: $(".circle-navy").css("background-color"),
                };

                context.textAlign = "center";
                context.textBaseline = "bottom";
                context.font = `bold ${15 * screenPixelRatio}px Roobert-bold`;

                portfolioValue = formatter.formatCurrency(portfolioValue, 0);
                const offset = screenWidth === "small" ? 25 : 60;
                const textWidth = getTextWidth(portfolioValue, context.font);
                x = x + offset * screenPixelRatio + textWidth / 2;
                y = y + 8 * screenPixelRatio;

                const color = colors[name];
                const circleX = x - (8 * screenPixelRatio + textWidth / 2);
                const circleY = y - 8 * screenPixelRatio;

                context.fillStyle = color;
                context.beginPath();
                context.arc(circleX, circleY, 4 * screenPixelRatio, 0, 2 * Math.PI);
                context.fill();

                context.fillStyle = "#000000";
                context.fillText(portfolioValue, x, y);

                context.restore();
            }
        };
    }

    function updateContent({ popup, y }) {
        const value = formatter.formatCurrency(y, 0);

        $(popup).find("[data-id='value']").text(value);
    }

    function drawGraphForType({ canvas, type }) {
        let screenPixelRatio = devicePixelRatio;
        let screenWidth = $(window).width();
        if (type === "page") {
            if (screenWidth < 576) {
                screenWidth = "small";
            } else {
                screenWidth = "regular";
            }

            canvas.style.width = "100%";
        } else {
            screenPixelRatio = 1;
            screenWidth = "regular";
        }

        const { stateOfMarket } = getInputValues();
        const filteredResults = filterObjectByKeys(results, stateOfMarket, false);
        const css = getLineGraphCSS({ ...filteredResults, screenPixelRatio, screenWidth });

        const lineColourOne = $(".legend .circle-green").css("background-color");
        const lineColourTwo = $(".legend .circle-turquoise").css("background-color");
        const lineColourThree = $(".legend .circle-navy").css("background-color");
        const dataset = getLineGraphDataset({
            ...filteredResults,
            drawCallback,
            lineColourOne,
            lineColourTwo,
            lineColourThree,
            screenPixelRatio,
            screenWidth,
        });

        const popup = sequenceGraph.closest(".graph-container").find(".popup");
        const options = getLineGraphOptions({
            ...results,
            hidePopup: hidePopup(popup),
            screenPixelRatio,
            screenWidth,
            showPopup: showPopup(popup, updateContent),
        });

        drawGraph(canvas, options, css, dataset);
    }

    const pageCanvas = sequenceGraph.get(0);
    pageCanvas.height = 530 * devicePixelRatio;
    pageCanvas.width = $(pageCanvas).parent().outerWidth() * devicePixelRatio;
    drawGraphForType({ canvas: pageCanvas, type: "page" });

    const printCanvas = sequenceGraphPrint.get(0);
    printCanvas.height = 560;
    printCanvas.width = 1128;
    drawGraphForType({ canvas: printCanvas, type: "print" });
}

function updateSRReturnsValues(state, results) {
    const tableRow = returnTable.find(`[data-value='${state}']`);
    tableRow.show();
    results[state].forEach((result) => {
        tableRow.find(`.return-value-${result.year}`).text(formatter.formatCurrency(result.portfolioValue, 0));
    });
}

function fillFieldsOnBlur() {
    // Ensures that inputs are not blank if user deletes number, fills input with 0
    $(".sequence-inputs")
        .find("input, select")
        .on("blur", () => {
            const values = getInputValues();

            for (const value in values) {
                if (!values[value]) {
                    values[value] = 0;
                }
            }

            $("#retirement-savings").val(formatter.formatNumber(values.totalRetirementSavings));
            $("#withdrawal-amount").val(formatter.formatNumber(values.withdrawalAmount));
            setInputMaxLengths();
        });
}

function setUpNumericInputs() {
    const elements = document.getElementsByClassName("numeric");

    for (let i = 0; i < elements.length; i++) {
        RMNumberInput(elements[i], { inputmode: "numeric" });
    }

    $(".numeric").on("focus", function () {
        let preVal = $(this).val();
        if (lang === "fr") {
            preVal = preVal.replace(/,/g, ".");
        }

        if (isNaN(preVal)) {
            if (lang === "fr") {
                preVal = preVal.replace(/\./g, ",");
            }

            let value = formatter.parseNumber(preVal).toString();

            if (lang === "fr") {
                value = value.replace(/\./g, ",");
            }

            $(this).val(value).trigger("select");
        } else {
            if (Number(preVal) > 0) {
                $(this).trigger("select");
            } else {
                $(this).val("");
            }
        }
    });

    $(".numeric").on("keyup", ({ target }) => {
        const input = $(target);

        input.val(input.val().replace(/\D/g, ""));
    });
}

function setInputMaxLengths() {
    const maxLengths = {
        retirementSavings: {
            decimal: 9,
            integer: 7,
        },
        withdrawalAmount: {
            decimal: 8,
            integer: 6,
        },
    };
    const inputNames = ["retirementSavings", "withdrawalAmount"];
    inputNames.forEach((inputName) => {
        const value = getValueFromInput(`[name=${inputName}]`);
        let numberType;

        if ((lang === "en" && value.indexOf(".") > -1) || (lang === "fr" && value.indexOf(",") > -1)) {
            numberType = "decimal";
        } else {
            numberType = "integer";
        }

        const maxLength = maxLengths[inputName][numberType];

        $(`[name=${inputName}]`).attr("maxlength", maxLength);
    });
}

function validation() {
    const values = getInputValues();
    let validity = true;

    if (values.totalRetirementSavings < 0 || values.totalRetirementSavings > 1000000) {
        $('[data-error="retirement-savings"]').show();
        $("#retirement-savings").attr("aria-invalid", "true");
        validity = false;
    } else {
        $('[data-error="retirement-savings"]').hide();
        $("#retirement-savings").removeAttr("aria-invalid");
    }

    if (values.withdrawalAmount < 0 || values.withdrawalAmount > 100000) {
        $('[data-error="withdrawal-amount"]').show();
        $("#withdrawal-amount").attr("aria-invalid", "true");
        validity = false;
    } else {
        $('[data-error="withdrawal-amount"]').hide();
        $("#withdrawal-amount").removeAttr("aria-invalid");
    }

    return validity;
}

function setupRealTimeErrorChecking() {
    $(".sequence-inputs")
        .find("input")
        .on({
            blur: (event) => {
                const id = event.currentTarget.id;
                const dataError = "[data-error='" + id + "']";
                const values = getInputValues();
                let val = "";

                switch (id) {
                    case "retirement-savings":
                        val = values.totalRetirementSavings;
                        if (val < 0 || val > 1000000) {
                            updateButton.prop("disabled", true);
                            printReportButton.prop("disabled", true);
                            pdfReportButton.prop("disabled", true);
                            sequenceGraphContainer.hide();
                            $(".sequence-img").show();
                            $(dataError).show();
                            $("#retirement-savings").attr("aria-invalid", "true");
                        }
                        break;
                    case "withdrawal-amount":
                        val = values.withdrawalAmount;
                        if (val < 0 || val > 100000) {
                            updateButton.prop("disabled", true);
                            printReportButton.prop("disabled", true);
                            pdfReportButton.prop("disabled", true);
                            sequenceGraphContainer.hide();
                            $(".sequence-img").show();
                            $(dataError).show();
                            $("#withdrawal-amount").attr("aria-invalid", "true");
                        }
                        break;
                }
            },

            keyup: (event) => {
                if (event.keyCode != 16 && event.keyCode != 9) {
                    const id = event.currentTarget.id;
                    const dataError = "[data-error='" + id + "']";
                    const values = getInputValues();
                    let val = "";

                    switch (id) {
                        case "retirement-savings":
                            val = values.totalRetirementSavings;
                            if (val <= 1000000) {
                                $(dataError).hide();
                                $("#retirement-savings").removeAttr("aria-invalid");
                            }
                            if ($("starting-amount-err-msg").is(":visible")) {
                                updateButton.prop("disabled", true);
                                printReportButton.prop("disabled", true);
                                pdfReportButton.prop("disabled", true);
                                sequenceGraphContainer.hide();
                                $(".sequence-img").show();
                            }
                            break;
                        case "withdrawal-amount":
                            val = values.withdrawalAmount;
                            if (val >= 0) {
                                $(dataError).hide();
                                $("#withdrawal-amount").removeAttr("aria-invalid");
                            }
                            if ($("withdrawal-amount-err-msg").is(":visible")) {
                                updateButton.prop("disabled", true);
                                printReportButton.prop("disabled", true);
                                pdfReportButton.prop("disabled", true);
                                sequenceGraphContainer.hide();
                                $(".sequence-img").show();
                            }
                            break;
                    }
                }
            },
        });
}

function setupStateOfMarketCheckboxes() {
    $("#state-of-market-checkboxes input").on("change", function () {
        const checkedCheckboxes = $("#state-of-market-checkboxes input:checked");

        if (checkedCheckboxes.length < 1) {
            $(this).prop("checked", true);
        }
    });
}

function scrollNav() {
    const nav = $("#pgNav");
    const width = nav.width() + 500;
    nav.scrollLeft(width);
}

function unhideIcon() {
    $("#pgNavTaggle").on("click", () => {
        $(".fa-chevron-up").css("display", "");
    });
}

$(() => {
    if (window.location.search === "?pdf") {
        setupPreview();
        return;
    }

    setUpNumericInputs();
    setupStateOfMarketCheckboxes();
    setupButtons();
    setupVideo();
    fillFieldsOnBlur();
    setupRealTimeErrorChecking();
    setUpGraphResizing();
    setInputMaxLengths();
    scrollNav();
    unhideIcon();

    $(".sequence-inputs")
        .find("input, select")
        .on("change keyup focusout", () => {
            const values = getInputValues();
            if (values.withdrawalAmount >= 0 && validation()) {
                updateButton.removeAttr("disabled");
            }
        });

    window.onresize = () => {
        scrollNav();
    };
});
